import constants from '@/constants.js';
class ProgressChartHelperService {
    buildXAxisTitle (period, daySmoothing) {
        let periodLabel = 'Date';
        if (period) {
            if (period.key === constants.PERIOD.WEEK) {
                periodLabel = period.name + ' ending';
            } else if (period.key === constants.PERIOD.DAY) {
                periodLabel = daySmoothing > 1 ? `${daySmoothing} day average ending` : periodLabel;
            } else {
                periodLabel = period.name;
            }
        }
        return periodLabel;
    }
};

export const progressChartHelperService = new ProgressChartHelperService();
